module.exports = __webpack_public_path__ + "files/e50514828ba5dcf8f009bd4a3a3f6240.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/droidserif-bolditalic-webfont.woff2
// module id = 661
// module chunks = 60